import { CompetitorFamily, CompetitorMember } from "./external"

export function competitorFamilyUrl(family: Pick<CompetitorFamily, 'internalReference'>) {
    return `/external/portfolio/family/${encodeURIComponent(family.internalReference)}`
}

export function competitorMemberUrl(member: Pick<CompetitorMember, 'internalReference'>) {
    return `/external/portfolio/member/${encodeURIComponent(member.internalReference)}`
}
